/**
 * /about copy (2026-10-17) — one source for the page (pages/About.jsx) and the
 * server renderer (api/render.js). Facts only: no claims about certifications,
 * insurance or years in business.
 *
 * A paragraph is a list of pieces: plain strings, { to, text } for a page on
 * this site, or { href, text } for mailto:/tel: links.
 */
import { BUSINESS } from '../utils/brand';

export const ABOUT_TAGLINE = 'The person behind every Utah Realty Photos shoot';

export const ABOUT_SECTIONS = [
  {
    paragraphs: [
      ["I'm Thomas, the owner and photographer behind Utah Realty Photos. I'm based in Eagle Mountain and photograph listings for real estate agents, brokerages and homeowners across Utah County and the Wasatch Front."],
      ["Utah Realty Photos is a one-person business on purpose. The person you book is the person who shows up, shoots the home, edits the photos and answers your messages. Nothing gets handed off to a crew you've never met."]
    ]
  },
  {
    heading: 'How I work',
    paragraphs: [
      ['Prices are published and fixed, and you can book online at any time. Most packages are delivered within 24 hours of the shoot; the Essential package is delivered the next business day. Every gallery is MLS-ready.'],
      ['Beyond listing photos I offer video, Matterport 3D tours, virtual staging and virtual twilight photos. The full list, with prices, is on the ', { to: '/pricing', text: 'pricing page' }, ', and the areas I cover are on the ', { to: '/locations', text: 'service areas page' }, '.']
    ]
  },
  {
    heading: 'About the blog',
    paragraphs: [
      ['The ', { to: '/blog', text: 'blog' }, " answers the questions agents ask me most: how to get a home ready for photos, what listing media costs, and what helps a listing stand out. I review and approve every post before it's published."]
    ]
  },
  {
    heading: 'Get in touch',
    paragraphs: [
      ['Email ', { href: `mailto:${BUSINESS.email}`, text: BUSINESS.email }, ' or call or text ', { href: `tel:+1${BUSINESS.phone.replace(/\D/g, '')}`, text: BUSINESS.phone }, '.']
    ]
  }
];
